import { render } from "./z-money2.vue?vue&type=template&id=f9c65b0a"
import script from "./z-money2.vue?vue&type=script&lang=js"
export * from "./z-money2.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__